import * as Yup from "yup";

interface IDelayPayment extends Yup.MixedSchema {
  delayUntil: any;
}

export default () => {
  return Yup.object<IDelayPayment>().shape({
    delayUntil: Yup.string().required(
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALUE_INTO_THE_FIELD"
    ),
  });
};
